import React from 'react';
import PropTypes from 'prop-types';
import TranslationContainer from '../../../translation/translation_container';
import toDangerousReactHTML from '../../../../helper/to_dangerous_react_html';

export const PriceRrp = ({ price }) => (
    <TranslationContainer
        translationKey="product-tile-rrp"
        targetProperty="dangerouslySetInnerHTML"
        transform={toDangerousReactHTML}
        placeholder={{ price }}
    >
        <span className="product-tile__price-rrp" />
    </TranslationContainer>
);

PriceRrp.propTypes = {
    price: PropTypes.string.isRequired,
};
